import type DxfArrayScanner from '../../DxfArrayScanner';
import type { ScannerGroup } from '../../DxfArrayScanner';
import {
    createParser,
    DXFParserSnippet,
    Identity
} from '../../shared/parserGenerator';

function pseudoPointParser(curr: ScannerGroup, scanner: DxfArrayScanner) {
    const nextCode = curr.code + 1;
    const offset = {
        x: curr.value,
        y: 1,
    };

    const next = scanner.next();

    // Ensure next.value is a number before assigning
    if (next.code === nextCode) {
        offset.y = typeof next.value === 'number' ? next.value : 0; // or handle appropriately
    } else {
        scanner.rewind();
    }

    return offset;
}

const PatternDataSnippets: DXFParserSnippet[] = [
    {
        code: 49,
        name: 'dashLengths',
        parser: Identity,
        isMultiple: true,
    },
    {
        code: 79,
        name: 'numberOfDashLengths',
        parser: Identity,
    },
    {
        code: 45,
        name: 'offset',
        parser: pseudoPointParser,
    },
    {
        code: 43,
        name: 'base',
        parser: pseudoPointParser,
    },
    {
        code: 53,
        name: 'angle',
        parser: Identity,
    },
];

// eslint-disable-next-line import/prefer-default-export
export function parsePatternData(curr: ScannerGroup, scanner: DxfArrayScanner) {
    const patternData: any = {};
    createParser(PatternDataSnippets)(curr, scanner, patternData);
    return patternData;
}
